// initial state
const state = () => ({
  notifications: [],
});

// getters
const getters = {
  getNotifications: state => {
    return state.notifications;
  },
};

// actions
const actions = {
  load({ commit }) {
    return axios.get('/ajax/user/notification/unread')
      .then(response => {
        response.data.data.forEach((element) => {
          commit('addNotification', element);
        });
      });
  },
};

// mutations
const mutations = {
  setNotifications: (state, notifications) => {
    state.notifications = notifications;
  },
  addNotification: (state, notification) => {
    state.notifications.push(notification);
  },
  removeNotification: (state, notification) => {
    let index = state.notifications.findIndex((x) => {
      return x.id === notification.id;
    });
    state.notifications.splice(index, 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
